import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { isLoading, load } from '../reducers/fastCards';

import HorseRacingMeetingFastCards from '../components/HorseRacingMeetingFastCards';

const REFRESH_INTERVAL_MILLIS = 60 * 1000;

@standardAsyncConnect([
  {
    dispatch: ({params: {meetingId}}) => load(meetingId),
    preventResolve: ({state, params: {meetingId}}) => isLoading(state, meetingId),
    refreshInterval: REFRESH_INTERVAL_MILLIS,
    state: ({horseRacing: {fastCards}}, {params: {meetingId}}) => ({meeting: fastCards[meetingId].meeting})
  }
])
@catchLifeCycleErrors
export default class HorseRacingFastCards extends Component {
  static propTypes = {
    routes: PropTypes.array,
    meeting: PropTypes.object
  };

  render() {
    const {
      meeting,
      routes
    } = this.props;

    return (
      <HorseRacingMeetingFastCards {...{meeting, routes}}/>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingFastCards.js